(function(runtime) {
    var constants = {
        states: {
            fixedClass: 'ixp-sticky-container-fixed'
        },
        placeholderSelector: '[data-ixp-sticky-placeholder]',
        extensibility: {
            commands: {
                status: ':status'
            },
            events: {
                status: ':status'
            }
        }
    };

    var _ = runtime.components.dependencies._;
    var Modernizr = runtime.components.dependencies.Modernizr;
    constants = _.defaults(constants, runtime.components.constants);

    var statics = {
        getScaffolding: function(scaffoldingKey, builder, options) {
            return {
                style: {
                    customClass: builder.getDefaultTheme('stickycontainer')
                }
            };
        },

        togglePlaceholder: function($el, shouldStick) {
            var $elPlaceholder = $el.next(constants.placeholderSelector);

            var height = ($el.innerHeight() || 1) + 'px';
            if (shouldStick) {
                if (!$elPlaceholder.length) {
                    var elId = $el.data('liveball-rmw-root');
                    $el.after('<div data-ixp-sticky-placeholder="' + elId + '"></div>');
                    $elPlaceholder = $el.next(constants.placeholderSelector);
                }
                $elPlaceholder.show().css({height: height});
            } else if ($elPlaceholder.length) {
                $elPlaceholder.hide();
            }
        },
        rgbSearch: /.*?(\d+).*?(\d+).*?(\d+)/i
    };

    runtime.components.register('sticky_container', {
        stickyWrapperCss: {},
        stickyContainerCss: {},
        transition: {
            prop: 'background',
            duration: '',
            timing: ''
        },

        initialize: function(options) {
            if (this.inStudio) {
                return true;
            }

            this.$window = this.$(window);
            this.$document = this.$(document);
            this._embedViewportTop = 0;
            this._setStickyBackgroundTransitionStyle(this.sticky_background_transition);
            this._setStickyBackgroundTransitionDuration(this.sticky_background_transition_duration);
            this._setStickyTopOffset(this.sticky_top_offset);
            this._setStickyWidth(this.sticky_width);
            this._setStickyHeight(this.sticky_height);
        },

        onDocumentReady: function() {
            if (this.inStudio) {
                return true;
            }

            this._setStickyBackground(this.sticky_background);
            this._setStickyStyles();

            this._setStickyTracking(this.sticky_trigger);

            this.$window.on('resize' + this.eventNamespace, _.throttle(_.bind(this.onResize, this), 100));
            this.$window.on('message' + this.eventNamespace, _.bind(this.onMessage, this));

            return true;
        },

        onScroll: function() {
            this._toggleSticky();
        },

        onMessage: function(e) {
            e = (e && e.originalEvent) || e;
            if ((this.sticky_trigger || 'scroll') !== 'scroll' || !e || e.source !== window.parent || typeof e.data !== 'string' || e.data.charAt(0) !== '{') {
                return;
            }

            var data;
            try {
                data = JSON.parse(e.data);
            } catch (ex) {
                return;
            }

            if (data._type !== 'ixp:runtime:scroll' || typeof data.scrollTop !== 'number' || !isFinite(data.scrollTop)) {
                return;
            }

            this._embedViewportTop = Math.min(data.scrollTop, 0);
            this._toggleSticky();
        },

        onResize: function() {
            this._positionSticky();
        },

        onDestroy: function() {
            if (this.$window) {
                this.$window.off(this.eventNamespace);
            }
        },

        isSticking: function() {
            return this.$el.hasClass(constants.states.fixedClass);
        },

        _toggleSticky: function() {
            var isSticking = this.isSticking();
            var targetEl = isSticking ? this.$el.next(constants.placeholderSelector) : this.$el;

            var topPos = (targetEl[0].getBoundingClientRect().top || 0) + this._embedViewportTop;
            var stickyOffset = parseInt(this.stickyWrapperCss.top, 10) || 0;
            var shouldStick = topPos < stickyOffset;

            statics.togglePlaceholder(this.$el, shouldStick);
            this.$el.toggleClass(constants.states.fixedClass, shouldStick);
            this._positionSticky();

            if (this.inStudio && this.studioApp && isSticking != shouldStick) {
                this.studioApp.componentsManager.trigger('rmw:reflowed', {instanceId: this.instanceId});
            }
        },

        _positionSticky: function() {
            var isSticking = this.isSticking();
            var widthVal = this.stickyContainerCss['max-width'];

            // inside a full-height embed iframe, fixed is relative to the whole iframe, so pin to the parent viewport top
            var embedTop = this._embedViewportTop || 0;
            this.$el.css('top', isSticking && embedTop < 0 ? ((parseInt(this.stickyWrapperCss.top, 10) || 0) - embedTop) + 'px' : '');

            if (!isSticking || !widthVal) {
                this.$el.css('left', 0);
                return;
            }

            widthVal = parseInt(widthVal, 10);
            var windowWidth = this.$(window).outerWidth();

            if (widthVal >= windowWidth) {
                this.$el.css('left', 0);
            } else {
                var windowDiff = windowWidth - widthVal;
                this.$el.css('left', Math.floor(windowDiff / 2));
            }
            if (this.inStudio && this.studioApp) {
                this.studioApp.componentsManager.trigger('rmw:reflowed', {instanceId: this.instanceId});
            }
        },

        _setStickyStyles: function() {
            var rules = [];
            var elSelector = '#' + this.$el.attr('id');

            // sticky container
            var stickyWrapperRule = {
                selector: elSelector,
                declarations: []
            };

            this.$.each(this.stickyWrapperCss, function(key, value) {
                if (value !== '') {
                    stickyWrapperRule.declarations.push({property: key, value: value});
                }
            });

            if (this.stickyContainerCss.background && this.transition.timing) {
                var transitionVal = [this.transition.prop, this.transition.duration, this.transition.timing].join(' ');
                stickyWrapperRule.declarations.push({property: '-webkit-transition', value: transitionVal});
                stickyWrapperRule.declarations.push({property: '-moz-transition', value: transitionVal});
                stickyWrapperRule.declarations.push({property: '-ms-transition', value: transitionVal});
                stickyWrapperRule.declarations.push({property: '-o-transition', value: transitionVal});
                stickyWrapperRule.declarations.push({property: 'transition', value: transitionVal});
            }
            rules.push(stickyWrapperRule);

            // sticky container with fixed class
            var stickyContainerRule = {
                selector: elSelector + '.' + constants.states.fixedClass,
                declarations: []
            };

            this.$.each(this.stickyContainerCss, function(key, value) {
                if (value !== '') {
                    stickyContainerRule.declarations.push({property: key, value: value});
                }
            });

            rules.push(stickyContainerRule);

            this.addOrUpdateStyleBlock(rules);
        },

        _afterParamChange: function() {
            if (this.initialized) {
                this._setStickyStyles();
                if (this.sticky_trigger === 'scroll') {
                    this._toggleSticky();
                } else {
                    this._positionSticky();
                }
            }
        },

        // setups from params
        _setStickyTracking: function(val) {
            val = val || 'scroll';
            this.$el.removeClass(constants.states.fixedClass);
            this.$window.off('scroll' + this.eventNamespace);
            if (val === 'scroll') {
                this.$window.on('scroll' + this.eventNamespace, _.throttle(_.bind(this.onScroll, this), 100));
                _.defer(_.bind(this._toggleSticky, this));
            } else {
                this.$el.addClass(constants.states.fixedClass);
                this._positionSticky();
            }
        },

        _setStickyBackground: function(val) {
            if (!val && this.stickyContainerCss.background != null) {
                this.stickyContainerCss.background = '';
            } else if (val) {
                if (Modernizr.rgba === false && val.indexOf('rgba') !== -1) {
                    var rgbValues = statics.rgbSearch.exec(val);
                    val = 'rgb(' + rgbValues.slice(1).join(',') + ')';
                }
                this.stickyContainerCss.background = val + ' !important';
            }

            this._afterParamChange();
        },

        _setStickyBackgroundTransitionStyle: function(val) {
            if (!val || val === 'none') {
                this.transition.timing = null;
            } else {
                this.transition.timing = val;
            }

            this._afterParamChange();
        },

        _setStickyBackgroundTransitionDuration: function(val) {
            if (!val) {
                this.transition.duration = '100ms';
            } else {
                this.transition.duration = val + 'ms';
            }

            this._afterParamChange();
        },

        _setStickyTopOffset: function(val) {
            if (val == null || val === '') {
                this.stickyWrapperCss.top = 0;
            } else {
                this.stickyWrapperCss.top = val + 'px';
            }

            this._afterParamChange();
        },

        _setStickyWidth: function(val) {
            if (val == null || val === '') {
                this.stickyContainerCss['max-width'] = null;
            } else {
                this.stickyContainerCss['max-width'] = val + 'px';
            }

            this._afterParamChange();
        },

        _setStickyHeight: function(val) {
            if (val == null || val === '') {
                this.stickyContainerCss.height = '';
            } else {
                this.stickyContainerCss.height = val + 'px';
            }

            this._afterParamChange();
        },

        disallowedChildrenTypes: function() {
            return ['sticky_container'];
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getScaffolding(scaffoldingKey, builder, options);
        },

        onGetCommandMap: function() {
            var commands = {};
            commands[constants.extensibility.commands.status] = {
                fn: this._onCommandStatus
            };
            return commands;
        },

        _onCommandStatus: function(options) {
            var isSticking = this.isSticking();
            var stickingOffset = isSticking ? this.sticky_top_offset : 0;
            var width = this.$el.outerWidth();
            var height = this.$el.outerHeight();
            var scrollTop = this.$el.offset().top;
            var ee = {
                isSticking: isSticking,
                sticksTo: 'top',
                offset: stickingOffset,
                width: width,
                height: height,
                scrollTop: scrollTop
            };
            this.triggerExtensibility(constants.extensibility.events.status, ee, { done: options && options.done });
        }
    });
})(window.ixp.runtime);
